
export interface ProposalCopyingForRecalSearchCriteria {
    companyCode: string | null,
    proposalNo?: string | null,
    operatingTml?: string | null,
    effectiveDateFrom?: Date | null,
    effectiveDateTo?: Date | null,

    [key: string]: string[] | string | boolean | number | Date | null | undefined
}

export const EMPTY_PROPOSAL_COPY_FOR_RECAL_SEARCH_CRITERIA: ProposalCopyingForRecalSearchCriteria = {

    companyCode: null,
    proposalNo: null,
    operatingTml: null,
    effectiveDateFrom: null,
    effectiveDateTo: null,
}